import {
  BrowserRouter,
  Navigate,
  Routes as ReactDomRoutes,
  Route,
} from 'react-router-dom';

// import { Home } from './home';
import { ProtectedRoutes } from './ProtectedRoutes';
import { Sandbox } from './sandbox';

import {
  Cards,
  Dashboard,
  FAQ,
  Home,
  Newcard,
  Referral,
  Services,
  Settings,
  Terms,
  VerificationIssues,
} from './ui';


const Routes = () => {
  return (
    <BrowserRouter>
      <ReactDomRoutes>
        <Route path='/' element={<Home />} />
        <Route element={<ProtectedRoutes />}>
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/services' element={<Services />} />
          <Route path='/faq' element={<FAQ />} />
          <Route path='/profile' element={<Settings />} />
          <Route path='/terms' element={<Terms />} />
          <Route path='/referral' element={<Referral />} />
          <Route
            path='/help/verification-issues'
            element={<VerificationIssues />}
          />
          <Route path='/cards'>
            <Route index element={<Cards />} />
            <Route path='new' element={<Newcard />} />
          </Route>
          {/* //////////////////////// */}
          {import.meta.env.VITE_SHOW_SANDBOX_PAGE === 'true' && (
            <Route path='/sandbox' element={<Sandbox />} />
          )}
        </Route>
        <Route path='*' element={<Navigate to='/' replace />} />
      </ReactDomRoutes>
    </BrowserRouter>
  );
};

export default Routes;
